import { combineReducers } from '@reduxjs/toolkit';
import organizerCommonReducer from './organizer';
import socialNetsReducer from './social-nets/social-nets-store';

/**
 * Состояние текущей организации одной веткой. Раньше это были два корневых ключа
 * стора — `organizer` и `socialNets`, — хотя соцсети принадлежат организации и
 * отдельным доменом верхнего уровня не являются.
 *
 * `common` (а не `info`): внутри самого слайса уже есть поле `info` с данными
 * организации, и `organizer.info.info` читалось бы плохо.
 */
const organizerReducer = combineReducers({
  common: organizerCommonReducer,
  socialNets: socialNetsReducer,
});

export default organizerReducer;
